import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';

import BadgeMessageDialog from './BadgeMessageDialog';

import { UserTypes } from '../constants';
import { T } from '../constants/tokens';

const useStyles = makeStyles({
  button: {
    fontFamily: 'inherit',
    fontSize: 14,
    fontWeight: 500,
    height: 36,
    padding: '0 14px',
    borderRadius: 6,
    border: '1px solid ' + T.hairline,
    background: T.elevated,
    color: T.ink,
    cursor: 'pointer',
    whiteSpace: 'nowrap',
    '&:hover': { background: T.surfaceSoft },
    '&:focus-visible': { outline: '2px solid ' + T.focus, outlineOffset: 2 }
  }
});

/**
 * "Send message" on a staff member's panel: a message on their badge's
 * screen. For Admin, IT and Super, as the server requires.
 */
function BadgeMessageButton({ badge, holderName, canSend }) {
  const classes = useStyles();
  const [open, setOpen] = useState(false);

  if (!canSend || badge == null) return null;

  return (
    <div style={{ margin: '16px 0' }}>
      <button type='button' className={classes.button} onClick={() => setOpen(true)}>
        Send message to badge
      </button>
      <BadgeMessageDialog open={open} onClose={() => setOpen(false)} badge={badge} holderName={holderName} />
    </div>
  );
}

BadgeMessageButton.propTypes = {
  badge: PropTypes.object,
  holderName: PropTypes.string,
  canSend: PropTypes.bool
};

/** Admin, IT and Super. By name as well, as LowPowerNotifications does. */
export const canMessageBadges = (userType) =>
  ['Admin', 'IT', 'Super'].includes(userType?.name) ||
  [UserTypes.ADMIN, UserTypes.IT, UserTypes.SUPER].includes(userType);

const mapStateToProps = (state) => ({
  canSend: canMessageBadges(state.auth.userType)
});

export default connect(mapStateToProps)(BadgeMessageButton);
